<template>
    <LayoutWithContainer>
        <template slot="header">
            <header id="content__header">
                <div style="display: flex; align-items: center; width: 100%; column-gap: 30px;">
                    <h1 style="margin-bottom: 0 !important;">Search</h1>
                    <div class="ai-checkbox">
                        <input id="public" type="checkbox" v-model="enableSynonyms">
                        <label for="public" title="We will use AI to generate synonyms of your query to broaden results">
                            <span>Broaden search using AI?</span>
                        </label>
                    </div>
                </div>
            </header>
        </template>
        <vue-tabs ref="tabs" @tab-change="onTabChange">
            <v-tab id="opportunities" title="Opportunities">
                <SearchPageOpportunities :query="searchQuery" :enable-synonyms="enableSynonyms" ref="opportunities"/>
            </v-tab>
            <v-tab id="madds" title="MADDs">
                <SearchPageMADDs :query="searchQuery" :enable-synonyms="enableSynonyms" ref="madds"/>
            </v-tab>
            <v-tab id="documents" title="Documents">
                <SearchPageDocuments :query="searchQuery" :enable-synonyms="enableSynonyms" ref="documents"/>
            </v-tab>
            <!-- <v-tab id="sector-posts" title="Sector Posts">-->
            <!--     <SearchPageSectorPosts :query="query" ref="sector-posts" />-->
            <!-- </v-tab>-->
            <v-tab id="users" title="Users">
                <SearchPageUsers :query="searchQuery" ref="users"/>
            </v-tab>
        </vue-tabs>
    </LayoutWithContainer>
</template>
<script>
import LayoutWithContainer from '@layouts/LayoutWithContainer';
import LayoutBase from '@components/Layout/LayoutBase';
import TabbedPage from '@components/TabbedPage';
import HeaderSearch from '@components/Header/HeaderSearch';

import SearchPageSectorPosts from './Tabs/SectorPosts';
import SearchPageDocuments from './Tabs/Documents';
import SearchPageOpportunities from './Tabs/Opportunities';
import SearchPageMADDs from './Tabs/MADDs';
import ListUsers from '@components/List/ListUsers.vue';
import SearchPageUsers from '@components/Search/Tabs/Users.vue';
import API from '@api';

export default {
    name: 'SearchPage',
    mixins: [TabbedPage],
    components: {
        SearchPageUsers,
        ListUsers,
        SearchPageOpportunities,
        SearchPageMADDs,
        SearchPageSectorPosts,
        SearchPageDocuments,
        HeaderSearch,
        LayoutWithContainer,
        LayoutBase,
    },
    props: {
        query: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            searchQuery: this.query,
            enableSynonyms: false,
            defaultTab: this.tab,
            tabRoute: 'search',
        }
    },
    watch: {
        '$route.params.query': {
            handler(newSearchTerm) {
                this.searchQuery = newSearchTerm;
            },
            immediate: true,
        },
    },
    methods: {
        async testSynonyms() {
            // const terms = ["car", "bedding", "oil", "freight", "electricity", "cybersecurity"];
            const terms = ['cybersecurity'];

            console.log('Testing Synonyms');
            try {
                const responses = await Promise.all(terms.map((term) => API.getSynonyms(term)))
                console.log({responses});
            } catch(err) {
                console.warn(err);
            } finally {
                console.log('finally')
            }

        },
        onTabChange(tabIndex, newTab, oldTab) {
            let id = newTab._props.id; //Get id attribute

            this.loadTab(id);

            if(this.tabRoute) {
                this.$router.replace({
                    name: this.tabRoute,
                    params: {
                        query: this.query,
                        tab: id,
                    },
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
#content__header {
    display: flex;
    flex-direction: column;

    h1 {
        margin-bottom: 1rem !important;
        display: block;
    }
}
</style>
